import { render, staticRenderFns } from "./AdminDataCollectionView.vue?vue&type=template&id=51fb3d37&scoped=true"
import script from "./AdminDataCollectionView.vue?vue&type=script&lang=js"
export * from "./AdminDataCollectionView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51fb3d37",
  null
  
)

export default component.exports